export var PasteTypes = {
  richText: 'richText',
  plain: 'plain',
  markdown: 'markdown',
  binary: 'binary'
};
export var PasteSources = {
  fabricEditor: 'fabric-editor',
  applePages: 'apple-pages',
  googleSpreadsheets: 'google-spreadsheets',
  googleDocs: 'google-docs',
  microsoftExcel: 'microsoft-excel',
  microsoftWord: 'microsoft-word',
  dropboxPaper: 'dropbox-paper',
  uncategorized: 'uncategorized'
};
export var PasteContents = {
  text: 'text',
  url: 'url',
  code: 'code',
  mediaSingle: 'mediaSingle',
  mediaCard: 'mediaCard',
  mediaGroup: 'mediaGroup',
  tableCells: 'tableCells',
  table: 'table',
  expand: 'expand',
  nestedExpand: 'nestedExpand',
  mixed: 'mixed',
  blockquote: 'blockquote',
  blockCard: 'blockCard',
  bodiedExtension: 'bodiedExtension',
  multiBodiedExtension: 'multiBodiedExtension',
  bulletList: 'bulletList',
  codeBlock: 'codeBlock',
  decisionList: 'decisionList',
  decisionItem: 'decisionItem',
  extension: 'extension',
  heading: 'heading',
  layoutSection: 'layoutSection',
  orderedList: 'orderedList',
  panel: 'panel',
  rule: 'rule',
  tableHeader: 'tableHeader',
  tableRow: 'tableRow',
  taskItem: 'taskItem',
  uncategorized: 'uncategorized'
};